// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2loaZ","colMin":"styles_colMin__Z62_b"};